module.exports = __webpack_public_path__ + "static/img/zuot.7cf45dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/zuot.png
// module id = MSmO
// module chunks = 5